import { useDispatch, useSelector } from 'react-redux';

import { useCallback, useEffect } from 'react';
import { setMessage } from '../../../../toasts/toastSlice';
import { useTranslation } from 'react-i18next';
import { handleAxiosErrorMessage } from '../../../../../utils';
import { useValidateOrderByQR } from '../../application/hooks';

export default function useHandleScanValidationError({ handleClose }) {
  const dispatch = useDispatch();
  const { t } = useTranslation(['system']);
  const { scanQROrder } = useSelector((store) => store.orders);

  const { isError, error } = useValidateOrderByQR({
    idOrder: scanQROrder,
  });

  const getErrorMessage = useCallback(
    (error) => handleAxiosErrorMessage(error),
    []
  );

  useEffect(() => {
    if (isError) {
      const message = getErrorMessage(error);
      dispatch(
        setMessage({
          body: t(message, { ns: 'system' }),
          type: 'error',
        })
      );
      handleClose();
    }
  }, [isError, dispatch, t, handleClose, getErrorMessage, error]);
}
